import { useEffect, useMemo, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

import { useTranslateContext } from "../../contexts/translate.context";

import { Phones } from "../../components/sub-render.component";
import TableContainer from "../../components/table-container.component";
import { useAlertMessageContext } from "../../contexts/alert-message.context";
import cduService from "../../services/cdu.service";
import { cpfMask } from "../../utilities/masks";
import { isEmpty } from "../../utilities/validators";
import { Button, FormControl, FormHelperText, Input, InputAdornment, InputLabel } from '@mui/material'
import { AlertMessageEnum } from "../../utilities/types";
import SearchIcon from '@mui/icons-material/Search';
import styles from './people.filter.module.scss';
import { usePartnerContext } from "../../contexts/partner.context";
import authService from "../../services/auth.service";

export interface IPeopleFilterProps {
    show: any,
    onClick_Close: any,
    onClick_Confirm: any,

    peopleNotInList?: any
}

export const PeopleFilter: React.FC<IPeopleFilterProps> = (props: IPeopleFilterProps) => {
    
    const alertContext = useAlertMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const title : string = display.title.people_filter;

    const [ textSearch, setTextSearch ] = useState('');
    const [record, setRecord] = useState({} as any);
    const [records, setRecords ] = useState([]);
    const [originalRecords, setOriginalRecords ] = useState([]);

    const columnsRecord = useMemo(() => [{
        Header: display.label.fullname,
        accessor: "fullname",
        Cell: (row: any) => (<div className="white-space">{row.value}</div>)
    },{
        Header: display.label.registration_pf,
        accessor: "registrationPf",
        Cell: (row: any) => (<div className="white-space">{cpfMask(row.value)}</div>)
    },{
        Header: display.label.telephone,
        accessor: 'phones',
        Cell: (row: any) => <Phones values={row.value} />
    },{
        Header: display.label.adresses,
        columns: [
            {
                Header: display.label.norm,
                accessor: "adresses[0].norm",
                Cell: (row: any) => (<div className="white-space">{display.label[row.value]}</div>)
            },{
                Header: display.label.city,
                accessor: "adresses[0].address.city",
                Cell: (row: any) => (<div className="white-space">{row.value}</div>)
            },{
                Header: display.label.state,
                accessor: "adresses[0].address.state",
                Cell: (row: any) => (<div className="white-space">{row.value}</div>)
            }
        ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }], []
    ); // columnsRecord

    async function initialize() {
        try {
            if (props.show) {
                const where = {} as any;
                if (props.peopleNotInList?.length > 0)
                    where['id'] = { notIn : props.peopleNotInList }

                const peoples = await cduService.peopleInPartner(partner.id);

                setRecords(peoples);
                setOriginalRecords(peoples);
                setRecord({} as any);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, title, error);
        }
    }

    useEffect(() => {
        if (isEmpty(partner))
            // eslint-disable-next-line react-hooks/exhaustive-deps
            partner = authService.currentPartner();

        initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.show]); // useEffect

    const filterRecords = (key?: string, value?: string) => {

        const filtered: any = []
        records.filter((record: any) => {
          if (
            record.fullname
              .toLocaleLowerCase()
              .includes(textSearch.toLocaleLowerCase()) ||
            record.registrationPf
              .toLocaleLowerCase()
              .includes(textSearch.toLocaleLowerCase())
          )
          filtered.push(record)
          return record
        })
        setRecords(filtered)
      return ''
    }

    useEffect(() => {
        if (textSearch.length >= 3) {
            filterRecords()
        } else if (textSearch.length < 3) {
          setRecords(originalRecords)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textSearch]);

    return (
        <Modal
            className={styles.filter}
            size="lg"
            show={props.show}
            centered
        >
            <Modal.Header>
                <Modal.Title><FaSearch />{title}</Modal.Title>
                <div className="card-actions float-right">
                    <FaTimes className="isClickable" size={22} onClick={props.onClick_Close} />
                </div>
            </Modal.Header>
            <Modal.Body style={{ minHeight : 400 }}>
                <Row>
                    <Col>
                        <FormControl fullWidth sx={{width: 300, marginBottom: 2 }} variant="standard">
                            <InputLabel className={styles.label} htmlFor="standard-adornment-amount">Pesquisar</InputLabel>
                            <Input id="standard-adornment-amount"
                                value={textSearch}
                                onChange={(e) => setTextSearch(e.target.value)}
                                endAdornment = {
                                    <InputAdornment position="end">
                                        <SearchIcon className='isClickable' />
                                    </InputAdornment>
                                }
                            />
                            <FormHelperText id="component-helper-text">
                                Nome ou CPF
                            </FormHelperText>
                        </FormControl>
                        <TableContainer columns={ columnsRecord } data={ records } viewPagination={true} setSelectedRow={ 
                            (event: any, dataRow: any) => { 
                                setRecord(dataRow); 
                            }}
                        />
                    </Col>
                </Row>                    
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col sm="8">
                            <div className="filter-selectred"><strong>{display.label.selected_record}:</strong> <span>{ record.fullname }</span></div>
                        </Col>
                        <Col sm="4">
                            <Button variant="contained" color="secondary" className="ms-2" onClick={ (e) => props.onClick_Close(e) } >{display.buttom.cancel}</Button>{' '}
                            <Button variant="contained" color="primary" onClick={ (e) => props.onClick_Confirm(e, record) }  disabled={isEmpty(record)}>{display.buttom.confirm}</Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    )
}

export default PeopleFilter;
